import Input from '../../../ui/input';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';

function EmergencyContact() {
  const { t } = useTranslation();
  const { 
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold opacity-[var(--sds-size-stroke-border)] text-sky-950">
        <Text>Emergency Contact</Text>
      </h2>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='emergencyContactName'>Contact Name *</Text>
          <Input
            {...register('emergencyContactName')}
            size='sm'
            label={<Text>Contact Name</Text>}
            placeholder="-"
            errorMessage={errors?.emergencyContactName?.message || null}
            isInvalid={errors?.emergencyContactName ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='emergencyPhoneNumber'>Phone Number *</Text>
          <Input
            {...register('emergencyPhoneNumber')}
            size='sm'
            label={<Text>Phone Number</Text>}
            placeholder={t('0123456789')}
            errorMessage={errors?.emergencyPhoneNumber?.message || null}
            isInvalid={errors?.emergencyPhoneNumber ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='emergencyRelationship'>Relationship *</Text>
          <Input
            {...register('emergencyRelationship')}
            size='sm'
            label={<Text>Relationship</Text>}
            placeholder='-'
            errorMessage={errors?.emergencyRelationship?.message || null}
            isInvalid={errors?.emergencyRelationship ? true : false}
          />
        </div>
      </div>
    </section>
  );
}

export default EmergencyContact;